function isSmallScreen() {
  return window.innerWidth <= 767;
}

export default isSmallScreen;
